export const META_ADS_TABS = [
  { value: "campaigns", label: "Campaigns" },
  { value: "adsets", label: "Ad Sets" },
  { value: "ads", label: "Ads" },
  { value: "leads", label: "Leads" },
] as const;

export function metaAdsActiveTab(tabParam: string | null): string {
  return META_ADS_TABS.some((t) => t.value === tabParam) ? (tabParam as string) : "campaigns";
}
